import { IControlOption } from '../../interface/Control'

export const defaultControlOption: Readonly<Required<IControlOption>> = {
  placeholderColor: '#9c9b9b',
  bracketColor: '#000000',
  prefix: '{',
  postfix: '}',
  borderWidth: 1,
  borderColor: '#000000',
  activeBackgroundColor: ''
}
